import React, { Component } from "react";
import NumberFormat, { NumberFormatValues } from 'react-number-format';
import INPUT_FORMATS from "../../formats/inputFormats"
import _ from 'lodash';

const {MDBInput} = require('mdbreact');

interface FormattedInputProps{
    name?:string;
    autoComplete?:string;
    label:string;
    readOnly?:boolean;
    format:'number'|'currency'|'phone';
    prefix?:string;
    id:string;
    decimalScale?:number;
    datagridfield?:boolean;
    hint:string;
    className?:string;
    required?:boolean;
    length?:number;
    showGroupSeparator?:boolean;
    disabled?:boolean;
    value:string;
    error:string;
    onChangeHandler?: (value?:string|null) => void;
    onValueChange?: (value:NumberFormatValues)=>void;
    onBlur?: () => void;
} 

interface FormattedInputState {
    oldValue?:string;
    value?:string;
    isTouched:boolean;
    error:string;
}

class FormattedInput extends Component<FormattedInputProps,FormattedInputState> {

    /* global BigInt */
    constructor(props:FormattedInputProps) {
        super(props);
        let paddedValue =  this.padWithScale(this.props.value);
        this.state= {
            oldValue: paddedValue||undefined,
            value: paddedValue||undefined,
            isTouched: false,
            error: ''
        }

    }

    componentDidUpdate(prevProps:FormattedInputProps,prevState:FormattedInputState) {
        let props = this.props;
        let state = this.state;
        if(prevProps.value != props.value && props.value != state.oldValue && props.value != state.value) {
            let value = this.padWithScale(props.value);
            this.setState({
                value: value||undefined,
                oldValue: value||undefined,
                isTouched: false,
            })
        }
    }

    onFocus = () => {
        this.setState({
            isTouched : true
        })
    }

    isCurrencyOrNumber = () => {
        return this.props.format === 'currency' || this.props.format === 'number';
    }
    onBlurHandler = () => {
        if(!this.state.value) {
            this.setState({isTouched: false, value:'', oldValue: ''});
        }
        if(this.state.value != this.state.oldValue) {
            let value = this.padWithScale(this.state.value)||undefined;
            this.setState({value:value, oldValue:value},() =>{
                this.props.onChangeHandler && this.props.onChangeHandler(value);
            });
        }
        this.props.onBlur && this.props.onBlur();
    }


    onValueChangeHandler = (e:NumberFormatValues) => {
        if(!this.props.length){
            this.setState({value:e.value}, ()=>{
            });
            this.props.onValueChange && this.props.onValueChange(e);
        }else {
            let currencyOrNumber = this.isCurrencyOrNumber();
            let stringLength;
            if(currencyOrNumber){
                // @ts-ignore e.value is a string !!!
                stringLength = e.value ? Math.floor(Math.abs(e.value)).toString().length : 0;
            }
            else stringLength = e.value ? e.value.toString().length : 0;
            if(stringLength <= this.props.length){
                this.setState({value:e.value});
                this.props.onValueChange && this.props.onValueChange(e);
            }else{
                this.setState({value:this.state.value});
            }
        }
    }
    padWithScale = (v: string | null | undefined) =>{
        let scale = this.props.decimalScale ? this.props.decimalScale : INPUT_FORMATS.FORMAT[this.props.format].decimalScale;
        if(!!v && scale && this.isCurrencyOrNumber()){
            // remove 0s from front if any
            let propsValue = Number(v) ? Number(v).toString() : v.toString();
            let splitPropsValue = propsValue.split('.');
            let valueScale = splitPropsValue && splitPropsValue.length > 1 ? splitPropsValue[1] : '';
            valueScale = _.padEnd(valueScale, scale, '0');
            let value = splitPropsValue && splitPropsValue[0] !== '' ? splitPropsValue[0] +'.'+ valueScale : propsValue;
            return value;
        }else{ 
            return v;
        }
    }
    render(){
        let id = this.props.id || this.props.name;
        if(!id){
            console.error(`FormattedInput: missing both id and name in props`, this.props);
            throw Error(`FormattedInput: missing both id and name in props`);
        }
        id = (id.charAt(0).toLowerCase() + id.slice(1)).replace(/\./g, "-");
        let label = this.props.label;
        let active = this.state.isTouched || ![null, '', undefined, "NaN"].includes(this.state.value);
        let newlabel = this.props.datagridfield ? '' : (this.props.required || this.props.readOnly || this.props.disabled ? label : (!active ? label + ' (optional)' : label));
        let className = 'ui-mdb-input-custom '+ (this.props.disabled? "disabled " : "") + (this.props.className || '');
        let hasError = !!this.props.error;
        let tabindex = this.props.readOnly ? -1 : 0;
        // any format including null format prevents user from deleting minus sign. so we need to set it as undefined if no format is used
        // format=undefined allows user to delete minus with glitch: deleting minus sign will delete the last digit too. it is a bug we live with it now
        let format = INPUT_FORMATS.FORMAT[this.props.format].format ?? undefined;
        let mask = INPUT_FORMATS.FORMAT[this.props.format].mask ?? undefined;

        let decimalSeparator = INPUT_FORMATS.FORMAT[this.props.format].decimalSeparator;
        let decimalScale = this.props.decimalScale ? this.props.decimalScale : INPUT_FORMATS.FORMAT[this.props.format].decimalScale;
        let thousandSeparator = this.props.showGroupSeparator ? INPUT_FORMATS.FORMAT[this.props.format].thousandSeparator : '';
        let prefix= this.props.prefix ?this.props.prefix : INPUT_FORMATS.FORMAT[this.props.format].prefix;

      return (
            <div className={className}>
                <NumberFormat
                    autoComplete={this.props.autoComplete}
                    value={this.state.value || ''}
                    customInput={MDBInput}
                    disabled={this.props.disabled}
                    label={newlabel}
                    labelClass={'no-break ' + (this.props.readOnly ? 'active' : '')}
                    placeholder={this.props.hint}
                    tabIndex={tabindex}
                    className = {`${hasError ? 'is-invalid' : ''}`}
                    id={id}
                    onValueChange={(v) =>{this.onValueChangeHandler(v)}}
                    onFocus={this.onFocus}
                    onBlur={this.onBlurHandler}
                    format= {format}
                    mask = {mask}
                    thousandSeparator={thousandSeparator}
                    prefix={prefix || undefined}
                    suffix={INPUT_FORMATS.FORMAT[this.props.format].suffix}
                    decimalSeparator={decimalSeparator||undefined}
                    decimalScale = {decimalScale||undefined}
                />
                <div className={"invalid-feedback"} style={{display: hasError && !this.props.readOnly? 'block': 'none'}}>{this.props.error}</div>
            </div>
        );
    }
}

export default FormattedInput;
